import React from "react";
import "./informativeMessage.scss";

export const InformativeMessage = ({ text, links }) => {
  return (
    <div className="informative-message">
      <div className="informative-message__icon informative-message__icon--logo"></div>
      <div className="informative-message__body">
        <div
          className="informative-message__text"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        ></div>
        {links.map((link) => {
          return link;
        })}
      </div>
    </div>
  );
};
